/**
 * Lightweight Markdown renderer for static CMS text.
 * Supports: # H1, ## H2, ### H3, blank-line paragraphs.
 * Intentionally tiny to avoid adding a dependency.
 */
export default function MarkdownText({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let buffer = [];

  const flushBuffer = (key) => {
    if (buffer.length === 0) return;
    const para = buffer.join(" ").trim();
    if (para) {
      blocks.push(
        <p key={key} className="font-body text-base text-stone-600 leading-relaxed mb-5">
          {para}
        </p>
      );
    }
    buffer = [];
  };

  lines.forEach((rawLine, i) => {
    const line = rawLine.trim();
    if (line === "") {
      flushBuffer(`p-${i}`);
      return;
    }
    if (line.startsWith("### ")) {
      flushBuffer(`p-${i}`);
      blocks.push(
        <h3 key={`h3-${i}`} className="font-heading text-lg font-semibold text-stone-900 mt-6 mb-2">
          {line.slice(4)}
        </h3>
      );
    } else if (line.startsWith("## ")) {
      flushBuffer(`p-${i}`);
      blocks.push(
        <h2 key={`h2-${i}`} className="font-heading text-xl font-semibold text-stone-900 mt-8 mb-3">
          {line.slice(3)}
        </h2>
      );
    } else if (line.startsWith("# ")) {
      flushBuffer(`p-${i}`);
      blocks.push(
        <h1 key={`h1-${i}`} className="font-heading text-3xl font-semibold text-stone-900 mb-6">
          {line.slice(2)}
        </h1>
      );
    } else {
      buffer.push(line);
    }
  });
  flushBuffer("p-end");

  return <div data-testid="markdown-content">{blocks}</div>;
}
